import { formTypes } from "../../types/form/types"
import { serverRequest } from "../../../utility/helpers/Axios/serverRequest"

export const handleChangeController = (name, value) => ({
    type: formTypes.inputChange,
    payload: { name, value }
})

export const initNormalForm = (structure) => ({
    type: formTypes.initForm,
    payload: structure
})

export const handleCleanForm = () => ({
    type: formTypes.cleanForm
})

export const fillFormData = (data) => ({
    type: formTypes.fillFormData,
    payload: { ...data }
})

export const handleStartEditing = (endpoint, id, structure = {}) => {
    return async (dispatch) => {
        if (!!id) {
            const data = await serverRequest(endpoint, id)
            if (!!data) {
                const objKeys = Object.keys(structure)
                Object.entries(data).map(([k, v]) => {
                    if (objKeys.includes(k) && v === null) data[k] = structure[k]
                })
                dispatch(fillFormData(data))
            }
        } else dispatch(fillFormData(structure))
    }
}

// PERMISSIONS

export const SwitchPermissionAll = (key, value) => ({
    type: formTypes.SwitchPermissionAll,
    payload: { key, value }
})

// TODO: PROBAR SI FUNCIONA CON editCollectionRegister
// export const fillSelect = (permisos, value) => {
//     return async (dispatch) => {
//         dispatch({
//             type: formTypes.FillSelect,
//             payload: { id: [permisos], value }
//         })
//     }
// }

// COLLECTION

export const addCollectionRegister = (key, name, structure = null) => {
    return async (dispatch) => {
        const collectionStructure = structure !== null ? structure : { main: false }
        dispatch({
            type: formTypes.addCollectionRegister,
            payload: { key, name, value: collectionStructure, addRepeater: true }
        })
    }
}

export const removeCollectionRegister = (key, position) => ({
    type: formTypes.removeCollectionRegister,
    payload: { key, position, removeRepeater: true }
})

export const editCollectionRegister = (key, obj, enumeration = null, customMTM = null) => ({
    type: formTypes.editCollectionRegister,
    payload: { key, ...obj, enumeration, customMTM }
})